(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blp-header"]) return;
  try {
    
(() => {
  if (window.blpNavigationReady) return;
  window.blpNavigationReady = true;
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.blp-nav--desktop > details')) return;
    details.parentElement.querySelectorAll(':scope > details[open]').forEach(other => { if (other !== details) other.open = false; });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const current = document.activeElement.closest('.blp-nav__department[open], .blp-mobile-menu[open]');
    if (current) { current.open = false; current.querySelector('summary').focus(); }
    else document.querySelectorAll('.blp-header details[open]').forEach(details => { details.open = false; });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.blp-header')) document.querySelectorAll('.blp-header details[open]').forEach(details => { details.open = false; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blp-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blp-product-shelf')) {
  customElements.define('blp-product-shelf', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-shelf-rail]');
      this.controls = this.querySelector('[data-shelf-controls]');
      this.previous = this.querySelector('[data-shelf-previous]');
      this.next = this.querySelector('[data-shelf-next]');
      if (!this.rail || !this.controls || !this.previous || !this.next) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.rail.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.update();
    }
    move(direction) {
      const card = this.rail.querySelector('.blp-home-product');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor(this.rail.clientWidth / step));
      const distance = direction * step * visible;
      const rtl = getComputedStyle(this.rail).direction === 'rtl';
      this.rail.scrollBy({ left: rtl ? -distance : distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const end = this.rail.scrollWidth - this.rail.clientWidth;
      const position = Math.abs(this.rail.scrollLeft);
      this.controls.hidden = end < 3;
      this.previous.disabled = position < 3;
      this.next.disabled = position >= end - 3;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
